/** Event & activity support and workshops from the app (1.5.1). Every write is a person's press. */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { ActivitiesResponse, WorkshopProposalView } from '@shared/activities';
import { apiFetch } from '@/lib/api';

export function useActivities(enabled = true) {
  return useQuery({ queryKey: ['activities'], queryFn: () => apiFetch<ActivitiesResponse>('/api/activities'), staleTime: 20_000, refetchOnWindowFocus: true, enabled });
}

export function useProposals(enabled = true) {
  return useQuery({ queryKey: ['workshop-proposals'], queryFn: () => apiFetch<{ proposals: WorkshopProposalView[] }>('/api/workshops/proposals'), staleTime: 20_000, enabled });
}

export function useMyProposals() {
  return useQuery({ queryKey: ['workshop-mine'], queryFn: () => apiFetch<{ proposals: WorkshopProposalView[] }>('/api/workshops/mine'), staleTime: 20_000 });
}

export const postJson = <T,>(url: string, body: unknown) => apiFetch<T>(url, { method: 'POST', body: JSON.stringify(body) });
export const pressActivity = <T,>(activityId: string, body: Record<string, unknown>) => postJson<T>(`/api/activities/a/${encodeURIComponent(activityId)}/press`, body);

/** After any press: the activities, the events, the proposals and the attention lists refresh. */
export function useActivityRefresh() {
  const qc = useQueryClient();
  return () => {
    for (const k of ['activities', 'events', 'workshop-proposals', 'workshop-mine', 'companion-attention', 'companion-tab']) void qc.invalidateQueries({ queryKey: [k] });
  };
}
